import React from "react";
import { Quote } from "lucide-react";
import { useLocale } from "../../i18n/LocaleContext";

export default function Outcomes() {
  const { t } = useLocale();
  const OUTCOMES = [
    { value: "12–18%", label: t("landing.outcomes.tile1") },
    { value: "60–80%", label: t("landing.outcomes.tile2") },
    { value: "1 of 6", label: t("landing.outcomes.tile3") },
    { value: "8–12 wk", label: t("landing.outcomes.tile4") },
  ];
  return (
    <section
      id="outcomes"
      data-testid="outcomes-section"
      className="relative bg-[#020617] text-white py-24 md:py-32 overflow-hidden border-y border-slate-900"
    >
      <div className="absolute inset-0 bg-grid-dark opacity-20" aria-hidden="true" />
      <div className="absolute -top-32 right-1/4 h-[420px] w-[420px] rounded-full bg-[#0072CE]/15 blur-3xl" aria-hidden="true" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Quote */}
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.22em] text-slate-400 font-semibold mb-4">
              <span className="inline-block h-px w-8 bg-white/20" />
              <span>{t("landing.outcomes.eyebrow_quote")}</span>
            </div>
            <Quote size={36} className="text-[#0072CE]/60 mb-4" strokeWidth={1.4} />
            <blockquote className="font-display text-2xl md:text-3xl lg:text-[34px] font-light tracking-tight leading-[1.18] text-white">
              <span className="text-slate-400">&ldquo;</span>
              {t("landing.outcomes.quote")}
              <span className="text-slate-400">&rdquo;</span>
            </blockquote>
            <div className="mt-6 flex items-center gap-3">
              <div
                className="h-12 w-12 rounded-full flex items-center justify-center font-display font-bold text-white"
                style={{ background: "linear-gradient(140deg,#0072CE 0%, #1e3a8a 100%)" }}
              >
                MD
              </div>
              <div>
                <div className="font-semibold text-white">Marta de Wit</div>
                <div className="text-sm text-slate-400">{t("landing.outcomes.cpo_title")}</div>
              </div>
            </div>
          </div>

          {/* Outcomes grid */}
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.22em] text-slate-400 font-semibold mb-4">
              <span className="inline-block h-px w-8 bg-white/20" />
              <span>{t("landing.outcomes.eyebrow_grid")}</span>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {OUTCOMES.map((o) => (
                <div
                  key={o.label}
                  data-testid={`outcome-${o.value.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  className="rounded-2xl border border-white/10 bg-white/[0.03] p-5 md:p-6"
                >
                  <div className="font-display text-3xl md:text-4xl font-semibold tracking-tight text-white">
                    {o.value}
                  </div>
                  <div className="mt-2 text-sm text-slate-300/85 leading-snug">
                    {o.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
